<template>
  <div class="builder">
    <div class="builder__area">
      <draggable v-model="resource.languages[language].blocks">
        <section class="builder__block" v-for="(block, index) in resource.languages[language].blocks" :key="block.id">
          <header class="builder__blockHeader">
            <h2><font-awesome-icon :icon="['fal', builderBlocks[block.type].icon]"/>
            {{ builderBlocks[block.type].label }}</h2>

            <template v-if="block.type === 'editor'">
              <div class="builder__blockToolbar">
                <a @click="switchEditor(index)">
                  <font-awesome-icon :icon="['fal', 'code']" />
                </a>
                <a @click="removeBlock(index)">
                  <font-awesome-icon :icon="['fal', 'trash-alt']" />
                </a>
              </div>
            </template>

            <template v-else>
              <a @click="removeBlock(index)">
                <font-awesome-icon :icon="['fal', 'trash-alt']" />
              </a>
            </template>
          </header>

          <template v-if="block.type === 'editor'">
            <quill-editor v-if="block.editor != 'codemirror'" v-model="block.content"/>
            <codemirror v-else :ref="`builderHTML-${index}`" v-model="block.content" :options="htmlOptions"/>
          </template>

          <template v-else-if="block.type === 'html'">
            <div class="builder__code">
              <div class="builder__codeEditor">
                <label class="form__label">HTML</label>
                <codemirror :ref="`builderHTML-${index}`" v-model="block.html" :options="htmlOptions"></codemirror>
              </div>

              <div class="builder__codeEditor">
                <label class="form__label">CSS</label>
                <codemirror :ref="`builderCSS-${index}`" v-model="block.css" :options="cssOptions"></codemirror>
              </div>
            </div>
          </template>

          <template v-if="block.type === 'video'">
            <div class="builder__video">
              <label for="Url">Url:</label>
              <input type="text" v-model="block.url">
            </div>
          </template>

          <template v-if="block.type === 'accordion'">
            <div class="builder__accordions">
              <div v-for="(accordion, index) in block.accordions" :key="index" class="builder__accordion">
                <div class="builder__accordionsHeader" @click="selctedAccordion = accordion">
                  <p class="builder__accordionsTitle">{{ accordion.title }}</p>

                  <a @click="removeFromBlock(block.accordions, index)">
                    <font-awesome-icon :icon="['fal', 'trash-alt']" />
                  </a>
                </div>
                <div class="builder__accordionsContent" :class="{ 'builder__accordionsContent--active': selctedAccordion == accordion }">
                  <label for="Title">Title:</label>
                  <input type="text" v-model="accordion.title" placeholder="Accordion title">

                  <quill-editor v-model="accordion.content"/>
                </div>
              </div>
              <div class="builder__accordionsContent builder__accordionsContent--active">
                <button type="button" class="btn btn--primary mt1" @click="addAccordion(block)">Add accordion</button>
              </div>
            </div>
          </template>

          <template v-if="block.type === 'gallery'">
            <div class="builder__video">
              <div class="grid">
                <div class="grid__column--six">
                  <label for="Url">Gallery:</label>
                  <select class="form__input" v-model="block.gallery_id">
                      <option :value="slider.id" v-for="slider in sliders.data" :key="slider.id">{{ slider.title }}</option>
                  </select>
                  <div class="formToggle"><input type="checkbox" :name="`builderImageToggle-${index}`" :id="`builderImageToggle-${index}`" class="formToggle__checkbox" v-model="block.wrap">
                    <label :for="`builderImageToggle-${index}`" class="formToggle__label"><span>ON/OFF</span> Wrap in container</label>
                  </div>
                </div>
                <div class="grid__column--six">
                  <label for="style">Type:</label>
                  <select name="style" id="style" class="form__input" v-model="block.style">
                    <option value="slider">Slider</option>
                    <option value="one_column">One column</option>
                    <option value="two_columns">Two columns</option>
                    <option value="three_columns">Three columns</option>
                    <option value="four_columns">Four columns</option>
                    <option value="five_columns">Five columns</option>
                    <option value="six_columns">Six columns</option>
                  </select>
                </div>
              </div>
            </div>
          </template>

          <template v-if="block.type === 'news'">
            <div class="builder__video">
              <div class="grid">
                <div class="grid__column--six">
                  <label for="Url">News type:</label>
                  <select class="form__input" v-model="block.type_id">
                      <option :value="null">All types</option>
                      <option :value="type.id" v-for="type in types" :key="type.id">{{ type.name }}</option>
                  </select>
                </div>
                <div class="grid__column--six">
                  <label for="Url">Category:</label>
                  <select class="form__input" v-model="block.category_id">
                      <option :value="null">All categories</option>
                      <option :value="category.id" v-for="category in categories" :key="category.id">{{ category.title }}</option>
                  </select>
                </div>
                <div class="grid__column--twelve">
                  <div class="formToggle">
                    <input class="formToggle__checkbox" type="checkbox" name="`is_featured-${index}`" id="`is_featured-${index}`" :value="true" v-model="block.is_featured">
                    <label class="formToggle__label formToggle__label--large" for="`is_featured-${index}`"><span>ON/OFF</span> is featured</label>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-if="block.type === 'navigation'">
            <div class="builder__video">
              <div class="grid">
                <div class="grid__column--twelve">
                  <label for="Url">Navigation:</label>
                  <select class="form__input" v-model="block.navigation_id">
                      <option :value="navigation.id" v-for="navigation in navigations.data" :key="navigation.id">{{ navigation.title }}</option>
                  </select>
                </div>
              </div>
            </div>
          </template>

          <template v-else-if="block.type === 'image'">
            <div class="builder__image builder__image--noSettings">
              <UploadImage :label="false" :image.sync="block.src"/>
              <!-- <div class="form__group">
                <div class="formToggle"><input type="checkbox" :name="`builderImageToggle-${index}`" :id="`builderImageToggle-${index}`" class="formToggle__checkbox" v-model="block.wrap">
                  <label :for="`builderImageToggle-${index}`" class="formToggle__label"><span>ON/OFF</span> Wrap in container</label>
                </div>
                <label class="form__label" :for="`builderImageSelect-${index}`">Background position:</label>
                <select :id="`builderImageSelect-${index}`" :name="`builderImageSelect-${index}`" class="form__input" v-model="block.background_position">
                  <option value="left top">Left Top</option>
                  <option value="center top">Center Top</option>
                  <option value="right top">Right Top</option>
                  <option value="left center">Left Center</option>
                  <option value="center">Center</option>
                  <option value="right center">Right Center</option>
                  <option value="left bottom">Left Bottom</option>
                  <option value="center bottom">Center Bottom</option>
                  <option value="right bottom">Right Bottom</option>
                </select>
              </div> -->
            </div>
          </template>

          <template v-else-if="block.type === 'storeWorkTime'">
            <div class="builder__image">
              <UploadImage text="Store logo" :image.sync="block.image"/>
              <div class="form__group">
                <label for="Title">Store name:</label>
                <input type="text" v-model="block.title">

                <label for="Title">Mon - Fri:</label>
                <input type="text" v-model="block.monFri">

                <label for="Title">Mon - Thu:</label>
                <input type="text" v-model="block.monThu">

                <label for="Title">Mon - Sun:</label>
                <input type="text" v-model="block.monSun">

                <label for="Title">Mon:</label>
                <input type="text" v-model="block.mon">

                <label for="Title">Tue:</label>
                <input type="text" v-model="block.tue">

                <label for="Title">Wen:</label>
                <input type="text" v-model="block.wen">

                <label for="Title">Thu:</label>
                <input type="text" v-model="block.thu">

                <label for="Title">Fri:</label>
                <input type="text" v-model="block.fri">

                <label for="Title">Sat:</label>
                <input type="text" v-model="block.sat">

                <label for="Title">Sun:</label>
                <input type="text" v-model="block.sun">

                <label for="Title">Notes:</label>
                <input type="text" v-model="block.notes">
              </div>
            </div>
          </template>

          <template v-else-if="block.type === 'jobOffers'">
            <div class="builder__jobOffers">
              <div class="form__group">
                <label class="form__label">Ponuda za dućan:</label>
                <select v-model="block.store_id">
                  <option :value="store.id" v-for="store in stores" :key="store.id">{{ store.title }}</option>
                </select>
              </div>
              <div class="form__group">
                <label for="Title">Title:</label>
                <input type="text" v-model="block.title">
              </div>
              <div class="form__group">
                <label for="Title">Job description:</label>
                <quill-editor v-model="block.content"/>
              </div>
            </div>
          </template>

          <template v-if="block.type === 'workTimeColumns'">
            <div class="builder__workTimeColumns">
              <div v-for="(workTime, index) in block.workTimes" :key="index" class="builder__workTimeColumn">
                <div class="grid">
                  <div class="grid__column--twelve">
                    <label for="Title">Title:</label>
                    <input type="text" v-model="workTime.title">
                  </div>
                  <div class="grid__column--three">
                    <label for="Mon-Fri">Mon-Fri:</label>
                    <input type="text" v-model="workTime.monFri">
                  </div>
                  <div class="grid__column--three">
                    <label for="Sat">Sat:</label>
                    <input type="text" v-model="workTime.sat">
                  </div>
                  <div class="grid__column--three">
                    <label for="Sun">Sun:</label>
                    <input type="text" v-model="workTime.sun">
                  </div>
                  <div class="grid__column--three grid__column--alignByInputs">
                      <a class="btn btn--primary btn--large" @click="removeFromBlock(block.workTimes, index)">
                        <font-awesome-icon :icon="['fal', 'trash-alt']" /> Delete
                      </a>
                  </div>
                </div>
              </div>
              <div class="builder__workTimeColumnContent">
                <button type="button" class="btn btn--primary mt1" @click="addWorkTime(block)">Add work time</button>
              </div>
            </div>
          </template>
        </section>
      </draggable>

      <p class="builder__message"><font-awesome-icon :icon="['fal', 'smile-plus']" class="navigation__icon"/><br /> <strong>Choose a block</strong> from our list to add additional elements.</p>
    </div>

    <ul class="builderNav grid__column--four">
      <li><span>+</span> <font-awesome-icon :icon="['fal', 'file-alt']" class="navigation__icon"/>
        <ul>
          <li v-for="(block, type) in builderBlocks" :key="block.id"><a @click="addBlock({ type: type }, block.contents)"><font-awesome-icon :icon="['fal', block.icon]" class="navigation__icon"/> {{ block.label }}</a></li>
        </ul>
      </li>
    </ul>
    <button type="submit" class="btn btn--primary btn--fixedBuilder mt1" v-if="action === 'create'">Publish</button>
    <button type="submit" class="btn btn--primary btn--fixedBuilder mt1" v-else>Update</button>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import UploadImage from '@/components/Utils/UploadImage'
import * as types from '@/store/types.js'
import Slider from '@/model/Slider'
import Navigation from '@/model/Navigation'
import { loadResource } from '@/helpers/resource'

// HTML editor
import { codemirror } from 'vue-codemirror'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/theme/neo.css'

export default {
  components: { UploadImage, draggable, codemirror },
  props: {
    data: {
      required: true
    },
    action: {
      required: true
    },
    stores: {
      required: true
    },
    language: {
      required: true
    }
  },
  computed: {
    sliders () {
      return this.$store.getters[types.ALL_SLIDERS]
    },
    categories () {
      return this.$store.getters[types.ALL_CATEGORIES]
    },
    types () {
      return this.$store.getters[types.ALL_TYPES]
    },
    navigations () {
      return this.$store.getters[types.ALL_NAVIGATIONS]
    },
    resource: {
      get: function () {
        return this.data
      },
      set: function (newValue) {
        this.$emit('update:data', newValue)
      }
    }
  },
  created () {
    loadResource(Slider, types.GET_ALL_SLIDERS, false, {allPages: 'true'})
    loadResource(Navigation, types.GET_ALL_NAVIGATIONS, false, {allPages: 'true'})
  },
  data () {
    return {
      builderBlocks: {
        'editor': {
          icon: 'align-left',
          label: 'Editor field',
          editor: 'wysiwyg',
          contents: {
            content: ''
          }
        },
        'image': {
          icon: 'image',
          label: 'Image',
          contents: {
            src: '',
            wrap: true,
            background_position: 'center'
          }
        },
        'gallery': {
          icon: 'images',
          label: 'Gallery',
          contents: {
            gallery_id: '',
            style: 'slider'
          }
        },
        'html': {
          icon: 'code',
          label: 'Code',
          contents: {
            html: '',
            css: ''
          }
        },
        'video': {
          icon: 'video',
          label: 'Video',
          contents: {
            url: ''
          }
        },
        'news': {
          icon: 'newspaper',
          label: 'News',
          contents: {
            type_id: null,
            is_featured: false,
            category_id: null
          }
        },
        'navigation': {
          icon: 'bars',
          label: 'Navigation',
          contents: {
            navigation_id: null
          }
        },
        'accordion': {
          icon: 'align-justify',
          label: 'Accordion',
          contents: {
            accordions: [{
              title: 'New accordion',
              content: ''
            }]
          }
        },
        'workTimeColumns': {
          icon: 'th',
          label: 'Work time Col',
          contents: {
            workTimes: [{
              title: '',
              monFri: '',
              sat: '',
              sun: ''
            }]
          }
        },
        'storeWorkTime': {
          icon: 'clock',
          label: 'Store Work time',
          contents: {
            image: null,
            title: '',
            monFri: '',
            monThu: '',
            monSun: '',
            mon: '',
            tue: '',
            wen: '',
            thu: '',
            fri: '',
            sat: '',
            sun: '',
            notes: ''
          }
        },
        'jobOffers': {
          icon: 'user',
          label: 'Job offers',
          contents: {
            store_id: '',
            title: '',
            description: ''
          }
        }
      },
      cssOptions: {
        tabSize: 2,
        mode: 'text/css',
        theme: 'neo',
        lineNumbers: true,
        lineWrapping: true,
        line: true
      },
      htmlOptions: {
        tabSize: 2,
        mode: 'text/html',
        theme: 'neo',
        lineNumbers: true,
        lineWrapping: true,
        line: true
      },
      selctedAccordion: null
    }
  },
  methods: {
    addBlock (type, contents) {
      const object = Object.assign(type, contents)

      if (type.type === 'accordion') {
        this.selctedAccordion = object.accordions[0]
      }

      this.resource.languages[this.language].blocks.push(object)
    },
    addAccordion (block) {
      block.accordions.push({
        title: '',
        content: ''
      })
      this.selctedAccordion = block.accordions[block.accordions.length - 1]
    },
    addWorkTime (block) {
      block.workTimes.push({
        title: '',
        monFri: '',
        sat: '',
        sun: ''
      })
    },
    removeBlock (index) {
      swal({
        title: 'Are you sure you want to remove this block?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.resource.languages[this.language].blocks.splice(index, 1)
        }
      })
    },
    removeFromBlock (contents, index) {
      swal({
        title: 'Are you sure you want to remove this?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          contents.splice(index, 1)
        }
      })
    },
    switchEditor (index) {
      if (this.resource.languages[this.language].blocks[index].editor === 'codemirror') {
        this.$set(this.resource.languages[this.language].blocks[index], 'editor', 'wysiwyg')
      } else {
        this.$set(this.resource.languages[this.language].blocks[index], 'editor', 'codemirror')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Utils/PageBuilder.vue